/**
 * Phoenix Graphics cart sync
 * - Listens for successful /cart/add, /cart/change, /cart/update requests
 *   and refreshes the header cart UI without a page reload.
 * - Intercepts the theme's built-in "Remove" link so it uses AJAX instead
 *   of navigating to /cart.
 * - Hides the cart count bubble when the cart is empty.
 * - Runs once on DOM ready so the initial empty state renders correctly.
 * Works regardless of whether the add was triggered by theme JS, PageFly, or a third-party app.
 */
(function () {
  'use strict';

  // --- Intercept fetch() calls ---
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    try {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;
      if (url && /\/cart\/(add|change|update)/.test(url)) {
        response.clone().json().then(() => refreshCartUI()).catch(() => {});
      }
    } catch (e) {}
    return response;
  };

  // --- Intercept XHR calls (older code paths) ---
  const originalXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._cartSyncUrl = url;
    return originalXHROpen.apply(this, arguments);
  };
  const originalXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this._cartSyncUrl && /\/cart\/(add|change|update)/.test(this._cartSyncUrl)) {
      this.addEventListener('load', () => {
        if (this.status >= 200 && this.status < 300) refreshCartUI();
      });
    }
    return originalXHRSend.apply(this, arguments);
  };

  // --- Intercept clicks on the built-in "Remove" link so they use AJAX ---
  document.addEventListener('click', async function (e) {
    const link = e.target.closest('.cart__item-remove a, a[href*="/cart/change"][href*="quantity=0"]');
    if (!link) return;

    const url = new URL(link.getAttribute('href'), window.location.origin);
    const id = url.searchParams.get('id');
    if (!id) return;

    e.preventDefault();

    // Optimistic UI: fade the row while we wait
    const row = link.closest('.cart__item');
    if (row) row.style.opacity = '0.5';

    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ id, quantity: 0 }),
      });
      // refreshCartUI() fires automatically via the fetch interceptor above

      // Also remove the row from the drawer immediately so the user sees it go
      if (row) row.remove();
    } catch (err) {
      if (row) row.style.opacity = '1';
      console.error('Cart remove failed:', err);
    }
  });

  // --- Refresh the header cart count + fire theme's cart events ---
  async function refreshCartUI() {
    try {
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());

      // Update common cart count elements (covers Archetype + most themes)
      const countSelectors = [
        '[data-cart-count]',
        '.cart-link__bubble-num',
        '.cart-count',
        '.site-header__cart-count',
        '.header__cart-count',
        '#CartCount',
      ];
      countSelectors.forEach((sel) => {
  document.querySelectorAll(sel).forEach((el) => {
    const wrapper = el.closest('.cart-link__bubble');

    if (cart.item_count > 0) {
      el.textContent = cart.item_count;
      el.classList.remove('is-empty', 'hide', 'hidden');
      el.removeAttribute('hidden');
      el.style.removeProperty('display');

      // Show the orange bubble wrapper
      if (wrapper) {
        wrapper.classList.add('cart-link__bubble--visible');
        wrapper.classList.remove('is-empty', 'hide');
      }
    } else {
      el.textContent = '';
      el.classList.add('is-empty', 'hide');
      el.style.setProperty('display', 'none', 'important');

      // Hide the orange bubble wrapper
      if (wrapper) {
        wrapper.classList.remove('cart-link__bubble--visible');
        wrapper.classList.add('is-empty', 'hide');
      }
    }
  });
});

      // Update cart subtotal if present
      document.querySelectorAll('[data-subtotal]').forEach((el) => {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          el.innerHTML = window.Shopify.formatMoney(cart.total_price);
        } else {
          el.textContent = `$${(cart.total_price / 100).toFixed(2)}`;
        }
      });

      // Toggle empty-cart state on the drawer
      const drawer = document.querySelector('header-cart-drawer');
      if (drawer) {
        if (cart.item_count === 0) {
          drawer.classList.add('is-empty');
        } else {
          drawer.classList.remove('is-empty');
        }
      }

      // Fire theme events so the cart drawer re-renders if it listens
      const events = ['cart:build', 'cart:updated', 'cart:refresh', 'cart:change'];
      events.forEach((name) => {
        document.dispatchEvent(new CustomEvent(name, { detail: { cart } }));
      });

      // Fallback: if Archetype exposes a global theme.cart / AjaxCart, try that too
      if (window.theme && typeof window.theme.Cart?.buildCart === 'function') {
        window.theme.Cart.buildCart(cart);
      }
    } catch (e) {
      // Silent fail — don't break the page
    }
  }

  // --- Run once on load so empty-cart state is applied on first paint ---
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshCartUI);
  } else {
    refreshCartUI();
  }
})();